import yup from '@/plugins/yup'
import { i18n } from '@/plugins/i18n'

const { t } = i18n.global

const AccountActivationSchema = yup.object({
  activation_token: yup
    .string()
    .required(t('errors.required', { label: t('views.account_activation.label.activation_token') }))
    .label(t('views.account_activation.label.activation_token')),
})

export default AccountActivationSchema
